import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllCitiesForSelectOptionsUseCaseInterface } from 'domain/usecases';

interface ICitiesForSelectOptions {
  citiesForSelectOptionsData: GetAllCitiesForSelectOptionsUseCaseInterface.Result;
}

interface IPayloadCitiesForSelectOptions
  extends PayloadAction<GetAllCitiesForSelectOptionsUseCaseInterface.Result> {}

const initialState: ICitiesForSelectOptions = {
  citiesForSelectOptionsData: [],
};

export const ICitiesForSelectSlice = createSlice({
  name: 'customersList',
  initialState,
  reducers: {
    loadCitiesForSelectOptionsData: (
      state,
      action: IPayloadCitiesForSelectOptions,
    ) => {
      state.citiesForSelectOptionsData = action.payload;
    },

    clearCitiesForSelectOptionsData: (state) => {
      state.citiesForSelectOptionsData = [];
    },
  },
});

export const {
  loadCitiesForSelectOptionsData,
  clearCitiesForSelectOptionsData,
} = ICitiesForSelectSlice.actions;

export default ICitiesForSelectSlice.reducer;
